import { EmpresaTreeViewService } from './../../../../employee/services/empresa-treeView.service';
import { AtributosService } from './../../../../company-view/services/atributos.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { PopupsComponent } from '../../popups/popups.component';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-employee-list',
    templateUrl: './employee-list.component.html',
    styleUrls: ['./employee-list.component.scss'],
    standalone: false
})
export class EmployeeListComponent implements OnInit {

  gridDataset: any[] = [];
  public selectedRowIndex = 0;
  displayedColumns: any[];
  attributeList=[];
  public isFirstTime:boolean=true;

  constructor(
    public selectionService: SelectionGenericService,
    public dialog: MatDialog, private employeeService: EmployeeService,
    private fileExportService: FileExportService, private sharedService: SharedService,
    private _atributosService: AtributosService,
    public empresaTreeViewService: EmpresaTreeViewService,
    private changeDetect: ChangeDetectorRef) {
      this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
        if (_res > 0) {
         
            this.isFirstTime=true;
            this.loadAttributes(_res)
        }
    }); 
  }

  public ngOnInit(): any {
    this.loadAttributes(parseInt(localStorage.getItem('Empresa')))
    this.selectionService.setPermissionForContextMenu();

   
  }
  refreshDisplayColumns()
  {
    this.displayedColumns = [
      { name: 'Actions', column: 'action', show: true, isPermit: true, disabled: true },
      { name: 'Empresa', column: 'empresa', show: true, isPermit: true, disabled: false },
      { name: 'Referencia', column: 'referencia', show: true, isPermit: true, disabled: false },
      { name: 'NIF', column: 'nif', show: false, isPermit: true, disabled: false },
      { name: 'Provincia', column: 'provincia', show: false, isPermit: true, disabled: false },
      { name: 'Poblacion', column: 'poblacion', show: false, isPermit: true, disabled: false },
      { name: 'CP', column: 'cp', show: false, isPermit: true, disabled: false },
      { name: 'Bloq', column: 'bloq', show: true, isPermit: true, disabled: false },
      { name: 'Nombre', column: 'nombre', show: true, isPermit: true, disabled: false },
      { name: 'Edad', column: 'edad', show: true, isPermit: true, disabled: false },
      { name: 'Jornada', column: 'jornada', show: true, isPermit: true, disabled: false },
      { name: 'Nivel 1', column: 'nivel1', show: false, isPermit: true, disabled: false},
      { name: 'Nivel 2', column: 'nivel2', show: false, isPermit: true, disabled: false},
      { name: 'Nivel 3', column: 'nivel3', show: false, isPermit: true, disabled: false},
      { name: 'Nivel 4', column: 'nivel4', show: false, isPermit: true, disabled: false},
      { name: 'Nivel 5', column: 'nivel5', show: false, isPermit: true, disabled: false},
      { name: 'Atributos', column: 'atributos', show: false, isPermit: true, disabled: false },
      {
        name: this.attributeList[0].attributoName,
        column: 'tAttr1',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[1].attributoName,
        column: 'tAttr2',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[2].attributoName,
        column: 'tAttr3',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[3].attributoName,
        column: 'tAttr4',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[4].attributoName,
        column: 'tAttr5',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[5].attributoName,
        column: 'tAttr6',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[6].attributoName,
        column: 'tAttr7',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[7].attributoName,
        column: 'tAttr8',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[8].attributoName,
        column: 'tAttr9',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[9].attributoName,
        column: 'tAttr10',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[10].attributoName,
        column: 'tAttr11',
        show: false,
        isPermit: true,
        disabled: false,
    },
    {
        name: this.attributeList[11].attributoName,
        column: 'tAttr12',
        show: false,
        isPermit: true,
        disabled: false,
    },
      { name: '> 3', column: 'alarmasB', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: '100 d.', column: 'alarmasD', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: '5,5%', column: 'alarmasA', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'NJ', column: 'alarmasJ', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'FPA > 60', column: 'alarmasP', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'Mot.Lab', column: 'alarmasL', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'No pres', column: 'alarmasR', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'Aus Act', column: 'alarmasS', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'Aus 12', column: 'alarmasU', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'I.P.', column: 'alarmasI', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'Insp.', column: 'alarmasK', show: true, isPermit: this.selectionService.selectionPermissions.HasAlarma, disabled: false },
      { name: 'Absentismo', column: 'absentismo', show: true, isPermit: true, disabled: false },
      { name: 'Bradford', column: 'bradford', show: true, isPermit: true, disabled: false },
      { name: 'Aviso', column: 'aviso', show: true, isPermit: this.selectionService.selectionPermissions.HasAviso, disabled: false }
    ];

    this.employeeService.trabadoreColumns=[];
        this.displayedColumns.forEach(element => {
            if(element.show) {
                this.employeeService.trabadoreColumns.push(element.name)
            }
        });
  }

  loadAttributes(empresaId)
  {
      this._atributosService.GetAttributoEmpresa(empresaId)
      .subscribe(res => {
      if (res.result) {
          this.attributeList=res.result;
          this.refreshDisplayColumns();
      }
      });
  }
  toggleDisplayColumn(columnName, value): any {
    this.displayedColumns.filter(c => c.column === columnName)[0].show = value;
    this.employeeService.trabadoreColumns=[];
        this.displayedColumns.forEach(element => {
            if(element.show) {
                this.employeeService.trabadoreColumns.push(element.name)
            }
        });
  }

  getDisplayedColumns(): string[] {
    //this.employeeService.trabadoreColumns = this.displayedColumns
    return this.displayedColumns.filter(cd => cd.show && cd.isPermit).map(cd => cd.column);
  }

  public getEmployees(pageEvent: PageEvent): void {
    this.selectionService.SearchEmployees(pageEvent.pageIndex, pageEvent.pageSize, false);
  }

  public DeleteEmployee(emp): void {
    this.OpenConfirmDialogForDelete(emp);
  }

  private OpenConfirmDialogForDelete(emp): void {
    const message = `¿Eliminar columninitivamente este trabajador, con todas sus bajas, sus actuaciones y tareas?`;
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.selectionService.isLoading = true;
        this.employeeService.DeleteEmployee(emp.trabajadorId).subscribe(res => {
          if (res.code === 0 && res.result) {
            const rowIndex = this.selectionService.dataSource.data.indexOf(emp);
            if (rowIndex > -1) {
              this.selectionService.dataSource.data.splice(rowIndex, 1);
              this.selectionService.dataSource.data = this.selectionService.dataSource.data;
            }
            this.sharedService.ShowSnackBar('Los trabajador fue eliminados con éxito.', 'Okay', 2000);

          } else {
            this.sharedService.ShowSnackBar('La eliminación del trabajador falló.', 'Okay', 2000);
          }
          this.selectionService.isLoading = false;
        }, err => {
          this.selectionService.isLoading = false;
          console.error(err);
        });

      }
    });
  }

  public UnlockEmployee(emp): void {
    this.selectionService.isLoading = true;
    this.employeeService.UnlockEmployee(emp.trabajadorId).subscribe(res => {
      if (res.code === 0 && res.result) {
        const rowIndex = this.selectionService.dataSource.data.indexOf(emp);
        if (rowIndex > -1) {
          this.selectionService.dataSource.data[rowIndex].importacionId = 1;
        }
        this.sharedService.ShowSnackBar('Desbloquear de trabajadores fue exitoso', 'Okay', 2000);
      } else {
        this.sharedService.ShowSnackBar('Trabajador desbloquear fallido', 'Okay', 2000);
      }
      this.selectionService.isLoading = false;
    }, err => {
      this.selectionService.isLoading = false;
      console.error(err);
    });
  }

  public getLeaveRecord(row, event): any {
    const isExcept = event.target.classList.contains('except');
    if (!isExcept && this.selectionService.isShowLeavePanel) {
      this.selectedRowIndex = row.trabajadorId;
      this.selectionService.getLeaveRecord(row);
    }
  }

  public TraspasarEmployee(): void {
    if (this.selectionService.dataSource.data.length > 0) {
      this.dialog.open(PopupsComponent, {
        width: '400px',
      });
    } else {
      this.sharedService.ShowSnackBar('La lista esta vacía', 'Okay', 2000);
    }
  }

  public DownloadExcel(): any {
    if (this.selectionService.dataSource.data.length > 0) {
      this.fileExportService.exportDatasetToExcel(this.selectionService.dataSource.data, 'Trabajadores-Selección');
    } else {
      this.sharedService.ShowSnackBar('La lista esta vacía', 'Okay', 2000);
    }
  }

  public DownloadWord(): any {
    if (this.selectionService.dataSource.data.length > 0) {
      this.fileExportService.exportWordDocument('Selection');
    } else {
      this.sharedService.ShowSnackBar('La lista esta vacía', 'Okay', 2000);
    }
  }
}
